/* eslint-disable camelcase */
/* eslint-disable no-unused-vars */
import {
    API_DOMAIN,
    API_DOMAIN_LOCAL,
    API_ENDPOINT_BASE_DOKAN,
    API_ENDPOINT_BASE_WC,
} from '../ApiEnv';

// Product Api

export const productsAPI = `${API_DOMAIN_LOCAL}${API_ENDPOINT_BASE_DOKAN}/products`;
export const productsWCAPI = `${API_DOMAIN_LOCAL}${API_ENDPOINT_BASE_WC}/products`;
export const productSummaryAPI = `${productsAPI}/summary`;
export const productAttributeAPI = `${productsAPI}/attributes`;
export const productCategoriesAPI = `${productsWCAPI}/categories`;

// v1 api endpoinsts
export const products_API_V1 = '/v1/products';

// v2 api endPoints
export const media_API_V2 = 'http://localhost:8888/dokan/wp-json/wp/v2/media';
